import "core-js/modules/es.array.push.js";
export default {
  props: {
    isWeb: {
      type: Boolean,
      default: false
    }
  },
  name: "Header",
  data() {
    return {
      nickName: "",
      faceIcon: "",
      userId: "",
      validate: "",
      isVip: 0,
      loginDailogShow: false,
      pageWidth: document.documentElement.clientWidth,
      pageHeight: document.documentElement.clientHeight
    };
  },
  mounted() {
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
    this.nickName = localStorage.getItem("edujia:group:web:userName");
    this.userId = localStorage.getItem("edujia:group:web:userid");
    this.isVip = localStorage.getItem("edujia:group:web:isVip");
  },
  methods: {
    loginDailogClick() {
      // this.loginDailogShow=!this.loginDailogShow;
      this.$emit("hide");
    },
    loginOut() {
      sessionStorage.clear();
      localStorage.clear();
      this.$store.commit("resetUserState");
      this.$store.commit("token", null);
      setTimeout(() => {
        window.location.reload();
      }, 100);
      if (!this.isWeb) {
        this.$router.push({
          name: "login"
        });
      } else {
        this.$router.push({
          name: "wlogin"
        });
      }
    }
  }
};